module.exports = __webpack_public_path__ + "static/media/logo-black-no-background.514489b0.png";